/**
 * Card for displaying/updating the user profile
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import TextField from '@material-ui/core/TextField';

import AccountCircle from '@material-ui/icons/AccountCircle';
import CollapsibleCard from './CollapsibleCard/CollapsibleCard';

const propTypes = {
  email: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    cardSubheader: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  className: null,
};

export function UnstyledProfileCard({ email, role, className, classes }) {
  return (
    <CollapsibleCard
      className={className}
      headerProps={{
        title: 'Profile Management',
        subheader: role,
        className: classes.content,
        classes: {
          subheader: classes.cardSubheader,
        },
        subheaderTypographyProps: {
          color: 'textPrimary',
        },
        avatar: <AccountCircle fontSize="large" color="secondary" />,
      }}
    >
      <TextField
        variant="outlined"
        label="Email"
        value={email}
        fullWidth
        className={classes.field}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
        }}
      />
    </CollapsibleCard>
  );
}

UnstyledProfileCard.propTypes = propTypes;
UnstyledProfileCard.defaultProps = defaultProps;

const styles = (theme) => ({
  cardSubheader: {
    textTransform: 'capitalize',
  },
  field: {
    marginTop: theme.spacing(1),
    '& label': {
      color: '#231f20 !important',
    },
  },
});

export default withStyles(styles)(UnstyledProfileCard);
